/** A step's question and the sentence under it — shared by every wizard step. */
export function stepHeading(title: string, sub?: string) {
  return (
    <div>
      <h2 className="q">{title}</h2>
      {sub ? <p className="q-sub">{sub}</p> : null}
    </div>
  );
}
